<template>
  <div id="app" class="min-h-screen flex flex-col">
    <TheHeader v-if="!isFullscreen" />
    <router-view class="flex-1" />
    <ThePartners v-if="!isFullscreen" />
    <TheFooter v-if="!isFullscreen" />
    <WhatsAppButton v-if="!isFullscreen" />
  </div>
</template>

<script>
import TheHeader from '@/components/layout/TheHeader.vue';
import TheFooter from '@/components/layout/TheFooter.vue';
import ThePartners from '@/components/layout/ThePartners.vue';
import WhatsAppButton from '@/components/ui/WhatsAppButton.vue';

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    ThePartners,
    WhatsAppButton
  },
  computed: {
    isFullscreen() {
      return this.$route && this.$route.meta && this.$route.meta.fullscreen;
    }
  }
};
</script>
